import styles from './Card.module.css'

const Card = ({ children, onClick }) => (
  <div onClick={onClick} className={styles.card}>
    {children}
  </div>
)

export default Card
